__turbopack_context__.v({
  "hidden": "EFvtqW_hidden",
  "secondary_text": "EFvtqW_secondary_text",
  "supporting_text": "EFvtqW_supporting_text",
  "title": "EFvtqW_title",
  "toggle_button": "EFvtqW_toggle_button",
});
